module.exports = __webpack_public_path__ + "static/hodel-56c1a02c391146884c41066d75ab4582.png";